
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid'
import Section from './Section'
import ReadOnly from './ReadOnly'

const CarInformationSection = ({ data }) => (
  <Section title="Car Information">
    <Grid
      container
      wrap="nowrap"
      sx={{
        overflowX: 'auto',
      }}>
      <ReadOnly label="Registration" value={data?.vehicleRegistration} />
      <ReadOnly label="Make" value={data?.manufacturerDescription} />
      <ReadOnly label="Model" value={data?.modelDescription} />
      <ReadOnly label="Tank Size" value={data?.tankSize} />
      <ReadOnly label="Vehicle Fuel Type" value={data?.milesFuelType} />
      <ReadOnly label="Driver" value={data?.driverName} />
    </Grid>
  </Section>
)

CarInformationSection.propTypes = {
  data: PropTypes.object,
}

CarInformationSection.defaultProps = {
  data: undefined,
}

export default CarInformationSection
